import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const progressThemeToken: any = {
  //======================== COLORS ========================//
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  circleTextColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  defaultColor: variableColors["ColorFigmaProductaccentAccent0150"],
  colorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  colorError: variableColors["ColorFigmaComplementaryBlue50"],
  remainingColor: variableColors["ColorFigmaNeutralGrayscaleGray40"],

  //========================= FONT ============================//
  fontSize: variableTypography["BodyLargeFontSize"],
  fontSizeSM: variableTypography["BodyLargeFontSize"],
};
